<template>
    <div class="basket">
        <div @click="toggleDropdown">
            <span class="count" v-if="count">{{ count }}</span>
            <i class="icon-cart"></i>
        </div>
        <header-basket-dropdown-new v-if="items.length && show"></header-basket-dropdown-new>
    </div>
</template>

<script>
/* global App */
import { createNamespacedHelpers } from 'vuex'
import HeaderBasketDropdownNew from './HeaderBasketDropdownNew.vue'

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('cart')

export default {

  components: {
    HeaderBasketDropdownNew
  },

  data () {
    return {
      show: false
    }
  },

  computed: {
    ...mapState(['items']),
    ...mapGetters(['count'])
  },

  created () {
    this.requestItems()

    App.dispatcher.listen('basket.dropdown.close', () => {
      this.show = false
    })
  },

  methods: {
    ...mapActions(['requestItems']),

    toggleDropdown () {
      this.show = !this.show
    }
  }
}
</script>
